import { render } from "./LegacyPlanHeroCard.vue?vue&type=template&id=c5272a0c&scoped=true"
import script from "./LegacyPlanHeroCard.vue?vue&type=script&lang=ts"
export * from "./LegacyPlanHeroCard.vue?vue&type=script&lang=ts"

import "./LegacyPlanHeroCard.vue?vue&type=style&index=0&id=c5272a0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c5272a0c"

export default script